import { render, staticRenderFns } from "./PdfPreview.vue?vue&type=template&id=5b960794"
import script from "./PdfPreview.vue?vue&type=script&lang=ts"
export * from "./PdfPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports